export var Model;
(function (Model) {
    function make(name, model = {}) {
        return {
            name,
            views: model.views || [],
            params: model.params || [],
        };
    }
    Model.make = make;
    function extend(model, view) {
        const views = [...model.views, view];
        return {
            ...model,
            views,
        };
    }
    Model.extend = extend;
    let Views;
    (function (Views) {
        function attrs(model, viewName) {
            const vAttrs = new Map();
            const view = find(model, viewName);
            if (view == null) {
                return [];
            }
            if (view.from.type === "VIEW") {
                for (const attr of attrs(model, view.from.name)) {
                    vAttrs.set(attr.name, attr);
                }
            }
            for (const join of view.joins || []) {
                for (const attr of attrs(model, join.alias)) {
                    vAttrs.set(attr.name, attr);
                }
            }
            for (const attr of view.attrs) {
                vAttrs.set(attr.name, attr);
            }
            return Array.from(vAttrs.values());
        }
        Views.attrs = attrs;
        function add(model, ...views) {
            const mViews = new Map();
            for (const view of model.views) {
                mViews.set(view.name, view);
            }
            for (const view of views) {
                mViews.set(view.name, view);
            }
            views = Array.from(mViews.values());
            return {
                ...model,
                views,
            };
        }
        Views.add = add;
        function remove(model, name) {
            const views = model.views.filter((v) => v.name !== name);
            return {
                ...model,
                views,
            };
        }
        Views.remove = remove;
        function find(model, viewName) {
            for (const view of model.views) {
                if (view.name === viewName) {
                    return view;
                }
            }
        }
        Views.find = find;
        function findAttr(model, viewName, attrName) {
            for (const attr of attrs(model, viewName)) {
                if (attr.name === attrName) {
                    return attr;
                }
            }
        }
        Views.findAttr = findAttr;
        function dimensions(model, viewName) {
            const dAttrs = [];
            for (const attr of attrs(model, viewName)) {
                if (attr.role === "DIMENSION") {
                    dAttrs.push(attr);
                }
            }
            return dAttrs;
        }
        Views.dimensions = dimensions;
        function measures(model, viewName) {
            const mAttrs = [];
            for (const attr of attrs(model, viewName)) {
                if (attr.role === "MEASURE") {
                    mAttrs.push(attr);
                }
            }
            return mAttrs;
        }
        Views.measures = measures;
    })(Views = Model.Views || (Model.Views = {}));
    let Params;
    (function (Params) {
        function add(model, param) {
            const params = [...(model.params || []), param];
            return {
                ...model,
                params,
            };
        }
        Params.add = add;
        function find(model, name) {
            for (const param of model.params || []) {
                if (param.name === name) {
                    return param;
                }
            }
        }
        Params.find = find;
    })(Params = Model.Params || (Model.Params = {}));
})(Model || (Model = {}));
